import React from 'react';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { MarketTicker } from '../components/MarketTicker';
import { MarketStrip } from '../components/MarketStrip';
import { HeroSection } from '../components/HeroSection';
import { BottomArticles } from '../components/BottomArticles';
import { AdPlaceholder } from '../components/AdPlaceholder';
export function Home2() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-470">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-471">
        <Header data-id="element-472" />
        <Navigation data-id="element-473" />

        {/* Top Banner Ad — above ticker in this variant */}
        <div className="py-4 md:py-6 flex justify-center" data-id="element-474">
          <AdPlaceholder width="w-full max-w-[728px]" height="h-[50px] md:h-[90px]" text="Wenda Ingredients Advertisement" data-id="element-475" />
        </div>
      </div>

      {/* Full-width ticker bar — below the ad banner */}
      <MarketTicker data-id="element-476" />

      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-477">
        <div className="pt-6" data-id="element-478" />
        <main data-id="element-479">
          <HeroSection data-id="element-480" />
          <BottomArticles data-id="element-481" />
          <MarketStrip data-id="element-482" />
        </main>

        {/* Bottom Banner Ad */}
        <div className="py-8 border-t border-gray-200 flex justify-center" data-id="element-483">
          <AdPlaceholder width="w-full max-w-[970px]" height="h-[50px] md:h-[90px]" text="Intralox Advertisement" data-id="element-484" />
        </div>
      </div>
    </div>;
}